import {
    FETCH_SLEEP_REPORT_DATA_FETCHING,
    FETCH_SLEEP_REPORT_DATA_SUCCESS,
    FETCH_SLEEP_REPORT_DATA_FAIL
} from '../../actions/ActionTypes';

import { SKIN_TEMP_MIN_MAX_VALUES } from 'utils/sleep/SleepConstants';

const INITIAL_STATE = {
    sleepReportData: null,
    isSleepReportDataFetching: false,
    didSleepReportDataFail: false,
    skinTempReportData: null,
    isSkinTempReportDataFetching: false,
    didSkinTempReportDataFail: false
};

// ======= Fetching Handlers =======
const fetchingSleepReportData = (state) => {
    return {
        ...state,
        isSleepReportDataFetching: true,
        didSleepReportDataFail: false
    };
};

const fetchSleepReportDataSuccess = (state, action) => {
    return {
        ...state,
        sleepReportData: action.data,
        isSleepReportDataFetching: false,
        didSleepReportDataFail: false
    };
};

const fetchSleepReportDataFail = (state, action) => {
    return {
        ...state,
        sleepReportData: null,
        isSleepReportDataFetching: false,
        didSleepReportDataFail: true
    };
};

// ======= Handler Assignments =======
const handlers = {
    [FETCH_SLEEP_REPORT_DATA_FETCHING]: fetchingSleepReportData,
    [FETCH_SLEEP_REPORT_DATA_SUCCESS]: fetchSleepReportDataSuccess,
    [FETCH_SLEEP_REPORT_DATA_FAIL]: fetchSleepReportDataFail
};

// ======= Default Action =======
export default function sleepReport(state = INITIAL_STATE, action = {}) {
    const handler = handlers[action.type];

    if (!handler) return state;
    return handler(state, action);
}

// ======= Selectors =======
export const getSleepReportData = (state, isMetricMeasurementSystem) => {
    const { sleepReportData } = state.sleepReport;
    if (!sleepReportData) {
        return null;
    }

    // weekly report
    if (!sleepReportData.overallStats) {
        return sleepReportData;
    }

    // daily report
    return {
        ...sleepReportData,
        overallStats: {
            ...sleepReportData.overallStats,
            averageSkinTemp: isMetricMeasurementSystem
                ? sleepReportData.overallStats.averageSkinTempC
                : sleepReportData.overallStats.averageSkinTempF
        },
        individualStats: sleepReportData.individualStats.map((dayValues) => {
            let value = isMetricMeasurementSystem ? dayValues.values.skinTempC : dayValues.values.skinTempF;

            if (value === undefined || isNaN(value)) {
                value = null;
            }

            if (isMetricMeasurementSystem) {
                if (value > SKIN_TEMP_MIN_MAX_VALUES.MAX_C || value < SKIN_TEMP_MIN_MAX_VALUES.MIN_C) {
                    value = null;
                }
            } else if (value > SKIN_TEMP_MIN_MAX_VALUES.MAX_F || value < SKIN_TEMP_MIN_MAX_VALUES.MIN_F) {
                value = null;
            }

            return {
                ...dayValues,
                values: {
                    ...dayValues.values,
                    skinTemp: value
                }
            };
        })
    };
};

export const isSleepReportDataFetching = (state) => {
    return state.sleepReport.isSleepReportDataFetching;
};

export const didSleepReportFetchFail = (state) => {
    return state.sleepReport.didSleepReportDataFail;
};
